import { cn } from "@/lib/utils";
import { Pressable, View } from "react-native";

import { Text } from "@/components/ui/text";
import {
    type FontAwesome6ProRegularIconName,
    type FontAwesome6ProSolidIconName,
} from "@react-native-vector-icons/fontawesome6-pro";
import { Icon } from "./icon";
import { ListSection, type ListSectionProps } from "./list-section";
import { type SectionProps } from "./section";

type SettingsItemProps = {
    label: string;
    description?: string;
    children?: React.ReactNode;
    onPress?: () => void;
    disabled?: boolean;
    className?: string;
    icon?: FontAwesome6ProSolidIconName | FontAwesome6ProRegularIconName;
    testID?: string;
    group?: boolean;
    selected?: boolean;
};

function SettingsItem({
    label,
    description,
    children,
    onPress,
    disabled,
    className,
    icon,
    testID,
    group,
    selected,
}: SettingsItemProps) {
    const content = (
        <View
            className={cn(
                "flex-row items-center px-4 py-3 justify-between gap-4",
                className,
            )}
        >
            <View className="flex-1 gap-4 flex-row items-center">
                {icon ? (
                    <Icon
                        name={icon}
                        iconStyle="regular"
                        size={16}
                        className="text-primary"
                    />
                ) : null}
                <Text>{label}</Text>
                {description ? (
                    <Text variant="muted">{description}</Text>
                ) : null}
            </View>
            {children}
            {selected ? (
                <Icon
                    name="check"
                    iconStyle="solid"
                    className="text-primary"
                    size={17}
                />
            ) : null}
            {group ? <SettingsChevron /> : null}
        </View>
    );

    if (onPress) {
        return (
            <Pressable
                testID={testID}
                accessibilityRole="button"
                disabled={disabled}
                onPress={onPress}
                className={cn("active:bg-accent/50", disabled && "opacity-50")}
            >
                {content}
            </Pressable>
        );
    }

    return content;
}

const SettingsChevron = () => {
    return (
        <Icon
            name="chevron-right"
            iconStyle="solid"
            className="text-muted-foreground"
            size={14}
        />
    );
};

function Settings(props: ListSectionProps) {
    return <ListSection {...props} />;
}
Settings.Item = SettingsItem;

export { Settings, SettingsChevron, SettingsItem };
export type { SectionProps, SettingsItemProps };

